import {
  GET_MODERATOR_AVAILABLE_COUNT,
  GET_MODERATOR_ANSWER,
  GET_NEXT_MODERATOR_ANSWER,
  GET_MODERATED_ANSWERS,
} from "./Queries";
import { SKIP_MODERATOR_ANSWER, SUBMIT_MODERATOR_FEEDBACK } from "./Mutations";

export class ModeratorClient {
  constructor(client) {
    this.client = client;
  }

  async getModeratorAvailableCount({ educationLevel, subject }) {
    const res = await this.client.query({
      query: GET_MODERATOR_AVAILABLE_COUNT,
      variables: { educationLevel, subject },
      fetchPolicy: "network-only",
    });
    return res.data.moderatorAvailableCount;
  }

  async getModeratorAnswer({ answer }) {
    const res = await this.client.query({
      query: GET_MODERATOR_ANSWER,
      variables: { answer },
      fetchPolicy: "network-only",
    });
    return res.data.anonymousAnswer;
  }

  async getNextModeratorAnswer({ educationLevel, subject, currentAnswer }) {
    const res = await this.client.query({
      query: GET_NEXT_MODERATOR_ANSWER,
      variables: { educationLevel, subject, currentAnswer },
      fetchPolicy: "network-only",
    });
    return res.data.nextModeratorAnswer;
  }

  async getModeratedAnswers({ educationLevel, subject }) {
    const res = await this.client.query({
      query: GET_MODERATED_ANSWERS,
      variables: { educationLevel, subject },
      fetchPolicy: "network-only",
    });
    return res.data.moderatedAnswers;
  }

  async skipModeratorAnswer({ answer }) {
    const res = await this.client.mutate({
      mutation: SKIP_MODERATOR_ANSWER,
      variables: { answer },
    });
    return res.data.skipModeratorAnswer;
  }

  async submitModeratorFeedback({ answer, aoMarks, feedback, areasToImprove }) {
    const res = await this.client.mutate({
      mutation: SUBMIT_MODERATOR_FEEDBACK,
      variables: { answer, aoMarks, feedback, areasToImprove },
    });
    return res.data.submitModeratorFeedback;
  }
}
